"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6866],{

/***/ 71800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_Button; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/atoms/Button/styled.tsx


var ButtonContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__ButtonContainer",
  componentId: "sc-nqd5s5-0"
})(["display:grid;place-content:center;padding:6px 12px;background-color:", ";color:", ";border:none;cursor:pointer;&:hover{background:", ";}", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.backgroundColor ? props.backgroundColor : props.theme.colors.theme.primary["default"];
}, function (props) {
  return props.theme.colors.text.white;
}, function (props) {
  return props.hoverBackgroundColor ? props.hoverBackgroundColor : props.theme.colors.theme.primary.dark;
}, function (props) {
  return props.disabled ? (0,styled_components_browser_esm/* css */.iv)(["pointer-events:none;background:", ";"], function (props) {
    return props.theme.colors.theme.primary.soft;
  }) : null;
}, function (props) {
  return props.variant === 'outline' ? (0,styled_components_browser_esm/* css */.iv)(["background-color:transparent;color:", ";border:2px solid #e9ecef;&:hover{background-color:transparent;color:", ";}"], function (props) {
    return props.theme.colors.text["default"];
  }, function (props) {
    return props.theme.colors.text.primary;
  }) : null;
}, function (props) {
  return props.disabled && props.variant === 'outline' ? (0,styled_components_browser_esm/* css */.iv)(["pointer-events:none;opacity:0.3;"]) : null;
}, function (props) {
  return props.variant === 'subtle' ? (0,styled_components_browser_esm/* css */.iv)(["background-color:transparent;color:", ";border:none;&:hover{background:", ";}"], function (props) {
    return props.theme.colors.text["default"];
  }, function (props) {
    return props.theme.colors.theme.neutralLight["default"];
  }) : null;
}, function (props) {
  return props.disabled && props.variant === 'subtle' ? (0,styled_components_browser_esm/* css */.iv)(["pointer-events:none;opacity:0.3;"]) : null;
}, function (props) {
  return props.variant === 'link' ? (0,styled_components_browser_esm/* css */.iv)(["padding:0;height:revert !important;background-color:transparent;color:", ";border:none;&:hover{background-color:transparent;text-decoration:underline;}"], function (props) {
    return props.theme.colors.text.primary;
  }) : null;
}, function (props) {
  return props.disabled && props.variant === 'link' ? (0,styled_components_browser_esm/* css */.iv)(["pointer-events:none;opacity:0.3;"]) : null;
}, function (props) {
  return props.block ? (0,styled_components_browser_esm/* css */.iv)(["width:100% !important;"]) : null;
});
var ButtonText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "styled__ButtonText",
  componentId: "sc-nqd5s5-1"
})(["cursor:pointer;margin:0;font-weight:700;font-size:14px;font-family:'PT Sans',sans-serif;", " ", ";user-select:none;-webkit-user-select:none;-moz-user-select:none;-khtml-user-select:none;-ms-user-select:none;"], function (props) {
  return props.size === 'xs' || props.size === 'sm' ? (0,styled_components_browser_esm/* css */.iv)(["font-size:14px;"]) : null;
}, function (props) {
  return props.size === 'md' || props.size === 'lg' ? (0,styled_components_browser_esm/* css */.iv)(["font-size:16px;"]) : null;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/atoms/Button/index.tsx


var _excluded = ["type", "onClick", "size", "disabled", "children", "variant", "block"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 //function that  take any number of arguments of any type and return a value of any type.


//In order to have code completion on the keys here, we create a Record<T,K> type referenced in /types/buttonStyle.ts
var buttonStyles = {
  xs: {
    height: 32,
    width: 'fit-content'
  },
  sm: {
    height: 40,
    width: 'fit-content'
  },
  md: {
    height: 48,
    width: 'fit-content'
  },
  lg: {
    height: 56,
    width: 'fit-content'
  }
};
/**
 *  Button Component with custom sizes and variants
 *
 */

var Button = function Button(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      onClick = props.onClick,
      size = props.size,
      disabled = props.disabled,
      children = props.children,
      variant = props.variant,
      block = props.block,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonContainer, _objectSpread(_objectSpread({
    type: type,
    onClick: onClick,
    style: buttonStyles[size],
    variant: variant,
    disabled: disabled,
    block: block,
    backgroundColor: props.backgroundColor,
    hoverBackgroundColor: props.hoverBackgroundColor
  }, rest), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonText, {
      size: size,
      children: children
    })
  }));
};

/* harmony default export */ var atoms_Button = (Button);

/***/ }),

/***/ 74398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ textInputHeights; }
/* harmony export */ });
/* harmony import */ var _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16835);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25018);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var textInputHeights = {
  sm: {
    container: {
      height: 40
    }
  },
  md: {
    container: {
      height: 48
    }
  },
  lg: {
    container: {
      height: 56
    }
  }
};

var TextInput = function TextInput(props) {
  var _props$type, _props$paddingLeft, _props$paddingRight;

  var fieldProps;

  if (!props.withoutFormik) {
    var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_1__/* .useField */ .U$)(props.name),
        _useField2 = (0,_Users_mike_Documents_Clients_SDM_DealerPortal_nextjs_webapp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useField, 3),
        field = _useField2[0],
        meta = _useField2[1],
        helpers = _useField2[2];

    fieldProps = field;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .TextInputContainer */ .ai, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .FieldWrapper */ .n2, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledField */ .ob, _objectSpread(_objectSpread({}, fieldProps), {}, {
        disabled: props.disabled,
        onChange: function onChange(e) {
          if (fieldProps) {
            fieldProps.onChange(e);
          } else if (props.onChange) {
            props.onChange(e.target.value);
          }
        },
        defaultValue: props.defaultValue,
        "data-testid": "field-".concat(props.name),
        name: props.name,
        placeholder: props.placeholder,
        type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'text',
        isError: props.errorMessage ? true : false,
        style: _objectSpread({
          height: textInputHeights[props.size].container.height - 1,
          paddingLeft: (_props$paddingLeft = props.paddingLeft) !== null && _props$paddingLeft !== void 0 ? _props$paddingLeft : 30,
          paddingRight: (_props$paddingRight = props.paddingRight) !== null && _props$paddingRight !== void 0 ? _props$paddingRight : 30
        }, props.styles)
      }))
    }), props.errorMessage ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledErrorMessage */ .Vv, {
      children: props.errorMessage
    }) : null]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TextInput);

/***/ }),

/***/ 25018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vv": function() { return /* binding */ StyledErrorMessage; },
/* harmony export */   "ai": function() { return /* binding */ TextInputContainer; },
/* harmony export */   "n2": function() { return /* binding */ FieldWrapper; },
/* harmony export */   "ob": function() { return /* binding */ StyledField; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14141);
/* harmony import */ var _Fonts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73648);


var TextInputContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styled__TextInputContainer",
  componentId: "sc-134ads-0"
})(["display:flex;flex-direction:column;width:100%;"]);
var StyledField = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "styled__StyledField",
  componentId: "sc-134ads-1"
})(["flex:1 1;border:solid 1px #ccc;:focus{outline:none;}font-family:'PT Sans';width:100%;"]);
var StyledErrorMessage = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Fonts__WEBPACK_IMPORTED_MODULE_0__/* .SubTitle */ .DK).withConfig({
  displayName: "styled__StyledErrorMessage",
  componentId: "sc-134ads-2"
})(["color:", ";margin-top:8px;"], function (props) {
  return props.theme.colors.text.danger;
});
var FieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styled__FieldWrapper",
  componentId: "sc-134ads-3"
})(["display:flex;width:100%;position:relative;"]);

/***/ }),

/***/ 7288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_ButtonWithIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(71800);
// EXTERNAL MODULE: ./src/components/atoms/Icon/index.tsx + 38 modules
var Icon = __webpack_require__(34876);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/molecules/ButtonWithIcon/styled.tsx


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "sc-xgnlex-0"
})(["display:flex;gap:", ";justify-content:center;text-align:center;", ""], function (props) {
  return props.noText ? "4px;" : "8px";
}, function (props) {
  return props.rightIcon ? (0,styled_components_browser_esm/* css */.iv)(["flex-direction:row-reverse;"]) : null;
});
var ButtonWithIconText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "styled__ButtonWithIconText",
  componentId: "sc-xgnlex-1"
})(["margin:0;font-weight:700;font-size:16px;font-family:'PT Sans',sans-serif;display:flex;align-items:center;", " ", ""], function (props) {
  return props.size === 'xs' || props.size === 'sm' ? (0,styled_components_browser_esm/* css */.iv)(["font-size:14px;"]) : null;
}, function (props) {
  return props.size === 'md' || props.size === 'lg' ? (0,styled_components_browser_esm/* css */.iv)(["font-size:16px;"]) : null;
}); //This wrapper will center the Icon in conjunction with text

var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__IconWrapper",
  componentId: "sc-xgnlex-2"
})(["display:flex;align-items:center;"]);
var Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Badge",
  componentId: "sc-xgnlex-3"
})(["background:", ";border-radius:50%;width:24px;height:24px;position:absolute;top:0;right:0;text-align:center;color:", ";"], function (props) {
  return props.theme.colors.theme.primary["default"];
}, function (props) {
  return props.theme.colors.text.white;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/molecules/ButtonWithIcon/index.tsx


var _excluded = ["type", "onClick", "size", "disabled", "children", "variant", "block", "iconName", "rightIcon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









/**
 *  Button Component with selactable icon on name props,
 *
 */
var ButtonWithIcon = function ButtonWithIcon(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      onClick = props.onClick,
      size = props.size,
      disabled = props.disabled,
      children = props.children,
      variant = props.variant,
      block = props.block,
      iconName = props.iconName,
      rightIcon = props.rightIcon,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var _useState = (0,react.useState)(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1]; //access theme outside of styled components


  var theme = (0,styled_components_browser_esm/* useTheme */.Fg)(); //get the size of the icon according to Button Size

  var getIconSize = function getIconSize() {
    if (size === 'xs' || size === 'sm') {
      return 16;
    }

    return 24;
  }; //get the IconColor depending on variant


  var getIconColor = function getIconColor() {
    if (variant === 'primary') {
      return theme.colors.text.white;
    }

    if (variant === 'outline') {
      if (isHovered) {
        return theme.colors.text.primary;
      }

      return theme.colors.text["default"];
    }

    if (variant === 'link') {
      return theme.colors.text.primary;
    }

    if (variant === 'subtle') {
      return theme.colors.text["default"];
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    style: {
      display: 'inline'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, _objectSpread(_objectSpread({
      type: type,
      onClick: onClick,
      size: size,
      variant: variant,
      disabled: disabled,
      block: block
    }, rest), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
        rightIcon: rightIcon,
        noText: props.children === undefined,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: iconName,
            size: getIconSize(),
            color: getIconColor()
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWithIconText, {
          size: size,
          children: children
        })]
      })
    })), props.badge ? /*#__PURE__*/(0,jsx_runtime.jsx)(Badge, {
      children: props.badge
    }) : null]
  });
};

/* harmony default export */ var molecules_ButtonWithIcon = (ButtonWithIcon);

/***/ }),

/***/ 95259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_LogoWithTitle; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./src/components/atoms/Fonts/index.tsx
var Fonts = __webpack_require__(73648);
;// CONCATENATED MODULE: ./src/components/molecules/LogoWithTitle/styled.tsx


var LogoWithTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__LogoWithTitleContainer",
  componentId: "sc-8pwjue-0"
})(["display:flex;flex-direction:column;align-items:center;"]);
var LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__LogoWrapper",
  componentId: "sc-8pwjue-1"
})(["margin-bottom:40px;"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(Fonts/* Header2 */.zV).withConfig({
  displayName: "styled__Title",
  componentId: "sc-8pwjue-2"
})(["color:", ";"], function (props) {
  return props.theme.colors.text.dark;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/molecules/LogoWithTitle/index.tsx
 // import logo from '/public/assets/images/logo/logo.png';




var LogoWithTitle = function LogoWithTitle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LogoWithTitleContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, {
      style: props.gap ? {
        marginBottom: props.gap
      } : {},
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: 'https://public.dealerportal.eyeforce.com/logo.png',
        alt: "Eyeforce",
        style: {
          width: 'auto',
          height: 50
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: props.title
    })]
  });
};

/* harmony default export */ var molecules_LogoWithTitle = (LogoWithTitle);

/***/ }),

/***/ 67368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_ProgressTracker; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/atoms/ProgressDot/ProgressDot.styled.tsx

var ProgressDotContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProgressDotstyled__ProgressDotContainer",
  componentId: "sc-9m7met-0"
})(["display:flex;flex-direction:column;border-radius:50%;width:16px;height:16px;margin:0;background:", ";"], function (props) {
  return props.isActive ? props.theme.colors.theme.primary["default"] : props.theme.colors.text.light;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/atoms/ProgressDot/ProgressDot.tsx



var ProgressDot = function ProgressDot(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ProgressDotContainer, {
    isActive: props.isActive
  });
};

/* harmony default export */ var ProgressDot_ProgressDot = (ProgressDot);
;// CONCATENATED MODULE: ./src/components/atoms/ProgressDot/index.tsx

/* harmony default export */ var atoms_ProgressDot = (ProgressDot_ProgressDot);
;// CONCATENATED MODULE: ./src/components/molecules/ProgressTracker/ProgressTracker.styled.tsx

var ProgressTrackerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProgressTrackerstyled__ProgressTrackerContainer",
  componentId: "sc-uqr70a-0"
})(["display:flex;"]);
var ProgressDotWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProgressTrackerstyled__ProgressDotWrapper",
  componentId: "sc-uqr70a-1"
})(["margin:0 12px;"]);
;// CONCATENATED MODULE: ./src/components/molecules/ProgressTracker/ProgressTracker.tsx




var ProgressTracker = function ProgressTracker(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ProgressTrackerContainer, {
    children: Array.from(Array(props.steps).keys()).map(function (n) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ProgressDotWrapper, {
        "data-testid": "progress-dot",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_ProgressDot, {
          isActive: props.activeStep === n
        })
      }, n);
    })
  });
};

/* harmony default export */ var ProgressTracker_ProgressTracker = (ProgressTracker);
;// CONCATENATED MODULE: ./src/components/molecules/ProgressTracker/index.tsx

/* harmony default export */ var molecules_ProgressTracker = (ProgressTracker_ProgressTracker);

/***/ }),

/***/ 98766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ portal_api_client; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(70594);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(29204);
;// CONCATENATED MODULE: ./src/lib/api/ApiClient.ts







var ApiConfiguration = /*#__PURE__*/(/* unused pure expression or super */ null && (_createClass(function ApiConfiguration() {
  _classCallCheck(this, ApiConfiguration);

  _defineProperty(this, "baseUrl", void 0);
})));

var ApiClient = /*#__PURE__*/function () {
  function ApiClient(apiConfiguration) {
    (0,classCallCheck/* default */.Z)(this, ApiClient);

    (0,defineProperty/* default */.Z)(this, "client", void 0);

    this.client = this.createAxiosClient(apiConfiguration);
  }

  (0,createClass/* default */.Z)(ApiClient, [{
    key: "createAxiosClient",
    value: function createAxiosClient(apiConfiguration) {
      return axios/* default.create */.Z.create({
        baseURL: apiConfiguration.baseUrl,
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true,
        timeout: 60 * 1000
      });
    }
  }, {
    key: "post",
    value: function () {
      var _post = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(path, payload, config) {
        var response, cause, message, _e$response, data;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!config) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return this.client.post(path, payload, config);

              case 4:
                _context.t0 = _context.sent;
                _context.next = 10;
                break;

              case 7:
                _context.next = 9;
                return this.client.post(path, payload);

              case 9:
                _context.t0 = _context.sent;

              case 10:
                response = _context.t0;
                return _context.abrupt("return", response.data);

              case 14:
                _context.prev = 14;
                _context.t1 = _context["catch"](0);
                //TODO: handle network error
                message = 'Could not complete POST Request';

                if (axios/* default.isAxiosError */.Z.isAxiosError(_context.t1)) {
                  data = (_e$response = _context.t1.response) === null || _e$response === void 0 ? void 0 : _e$response.data;

                  if (data !== null && data !== void 0 && data.error) {
                    cause = data.error;
                  }

                  message = _context.t1.message;
                }

                throw Error(message, {
                  cause: cause
                });

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 14]]);
      }));

      function post(_x, _x2, _x3) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(path, config) {
        var response, _error$response;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.client.get(path);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                if (_context2.t0 instanceof node_modules_axios/* AxiosError */.d7) {
                  console.log("GET error", (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status);
                } //TODO: handle error


                throw _context2.t0;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function get(_x4, _x5) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "patch",
    value: function () {
      var _patch = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(path, payload, config) {
        var response;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!config) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 4;
                return this.client.patch(path, payload, config);

              case 4:
                _context3.t0 = _context3.sent;
                _context3.next = 10;
                break;

              case 7:
                _context3.next = 9;
                return this.client.patch(path, payload);

              case 9:
                _context3.t0 = _context3.sent;

              case 10:
                response = _context3.t0;
                return _context3.abrupt("return", response.data);

              case 14:
                _context3.prev = 14;
                _context3.t1 = _context3["catch"](0);
                throw Error('Could not complete PATCH Request');

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 14]]);
      }));

      function patch(_x6, _x7, _x8) {
        return _patch.apply(this, arguments);
      }

      return patch;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(path, config) {
        var response;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (!config) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 4;
                return this.client["delete"](path, config);

              case 4:
                _context4.t0 = _context4.sent;
                _context4.next = 10;
                break;

              case 7:
                _context4.next = 9;
                return this.client["delete"](path);

              case 9:
                _context4.t0 = _context4.sent;

              case 10:
                response = _context4.t0;
                return _context4.abrupt("return", response.data);

              case 14:
                _context4.prev = 14;
                _context4.t1 = _context4["catch"](0);
                throw Error('Could not complete DELETE Request');

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 14]]);
      }));

      function _delete(_x9, _x10) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return ApiClient;
}();


;// CONCATENATED MODULE: ./src/lib/api/portal-api/client.ts

var client = new ApiClient({
  baseUrl: "https://api.dealerportal.eyeforce.com"
});
/* harmony default export */ var portal_api_client = (client);

/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 92777:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 82262:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

}]);